// extracted by mini-css-extract-plugin
export var typingIndicator = "_rv-0";